import { render } from "./Voting.vue?vue&type=template&id=d7d4fc0a&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"

import "./Voting.vue?vue&type=style&index=0&id=d7d4fc0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d7d4fc0a"

export default script